import { forwardRef, useImperativeHandle, useRef } from "react";
import type { TextInput } from "react-native";
import { type InputProps, Theme } from "tamagui";
import { useForwardFocus } from "../../utils/useForwardFocus";
import { FormError } from "../FormFields";
import { BentoInput } from "./inputParts";
type Props = {
  id?: string;
  label?: string;
  errorMessage?: string;
  // Tamagui flex issue with applying flex to the input itself on web does not work
  // so we need to apply it to the parent container. To limit its effect to
  // other components, we use a prop to toggle it.
  flexFullInput?: boolean;
} & InputProps;
export const FormInput = forwardRef<TextInput, Props>(function FormInput({
  id,
  label,
  errorMessage,
  disabled,
  flexFullInput = false,
  ...inputProps
}, ref) {
  const inputRef = useRef<TextInput | null>(null);
  const focusTrigger = useForwardFocus(inputRef);

  // Expose the internal input ref to parent components
  useImperativeHandle(ref, () => inputRef.current as TextInput, []);
  return <Theme name={errorMessage ? "red_alt2" : "granted"}>
      <BentoInput id={id} {...flexFullInput ? {
      flex: 1
    } : {}}>
        {label ? <BentoInput.Label htmlFor={id} size="$3" pb="$3">
            {label}
          </BentoInput.Label> : null}
        <BentoInput.Box disabled={disabled} {...focusTrigger}>
          <BentoInput.Area
        // Text Area form inputs should always default to have label styling for spacing
        hasLabel={true} overflow="hidden" flex={1} unstyled placeholderTextColor="alt1" disabled={disabled} ref={inputRef} {...inputProps} />
        </BentoInput.Box>
        <FormError errorMessage={errorMessage} />
      </BentoInput>
    </Theme>;
});